import { PreviewChoiceCard } from '../../../components/ui/preview-choice-card';
import {
  SPECIES_GATE_CAT_THUMB,
  SPECIES_GATE_DOG_THUMB,
} from './speciesGateAssets';
import { SpeciesSelectorHero } from './SpeciesSelectorHero';
import { SpeciesSelectorIntro } from './SpeciesSelectorIntro';

export type MatchQuizSpeciesGateProps = {
  onSelectSpecies: (species: 'Cat' | 'Dog') => void;
  /** Shown under the back link when the quiz is scoped to one shelter (public adopt flow). */
  shelterContextNote?: string | null;
};

export function MatchQuizSpeciesGate({
  onSelectSpecies,
  shelterContextNote,
}: MatchQuizSpeciesGateProps) {
  return (
    <div className='mx-auto max-w-6xl space-y-8 pb-8 pt-2 sm:space-y-10 sm:pb-10'>
      {/* <Link
        href={ROUTES.home}
        className={cn(
          buttonVariants({ variant: 'outlineHighlight', size: 'sm' }),
          'no-underline',
        )}
      >
        <ArrowLeftIcon className='size-4' aria-hidden />
        Back
      </Link> */}

      {shelterContextNote ? (
        <p className='max-w-2xl text-sm text-muted-foreground' role='note'>
          {shelterContextNote}
        </p>
      ) : null}

      <div className='flex flex-col gap-10 lg:grid lg:grid-cols-[minmax(0,1fr)_minmax(0,1.05fr)] lg:items-start lg:gap-12'>
        <div className='order-1 lg:sticky lg:top-8'>
          <SpeciesSelectorHero />
        </div>

        <div className='order-2 flex min-w-0 flex-col gap-8 lg:gap-10'>
          <SpeciesSelectorIntro />

          <div className='flex flex-col gap-4 lg:grid lg:grid-cols-2 lg:gap-6'>
            <PreviewChoiceCard
              title='Find me a Dog'
              // shortDescription='Loyal canine companions for every adventure.'
              // longDescription='Browse active, loyal, and loving canine companions ready for adventure.'
              imageSrc={SPECIES_GATE_DOG_THUMB}
              imageAlt='Golden retriever'
              onSelect={() => onSelectSpecies('Dog')}
            />
            <PreviewChoiceCard
              title='Find me a Cat'
              // shortDescription='Graceful feline friends for a peaceful home.'
              // longDescription='Discover gentle, independent, and soulful feline friends waiting for you.'
              imageSrc={SPECIES_GATE_CAT_THUMB}
              imageAlt='Orange tabby cat'
              onSelect={() => onSelectSpecies('Cat')}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
